import { isNil } from "lodash";
import React from "react";

import MaterialAPI from "../api/Material.api";
import { Material } from "../types";
import SearchBarAutocomplete from "./SearchBarAutocomplete";

type Props = {
  setMaterial: (material: Material | undefined) => void;
  material: Material | undefined;
  label: string;
};

export default function MaterialSearchableAutocomplete({
  label,
  material,
  setMaterial,
}: Props) {
  const [searchValue, setSearchValue] = React.useState<string>("");

  const { data } = MaterialAPI.useSearch({
    query: searchValue,
  });

  const options = data ? data.map((o) => ({ label: o.name, value: o })) : [];

  const value = isNil(material)
    ? { label: searchValue, value: searchValue }
    : { label: material.name, value: material };

  return (
    <SearchBarAutocomplete
      label={label}
      inputValue={searchValue}
      setSearchValue={setSearchValue}
      options={options}
      noOptionsText={"Material not found."}
      value={value}
      onChange={(event, newValue) => {
        if (isNil(newValue)) {
          setMaterial(undefined);
        } else {
          setMaterial(newValue.value);
        }
      }}
    />
  );
}
